import { createContext } from 'react';
export const JCdTransactionsContext = createContext({});
